import { segmentConditionCatalogSchema } from "@redotech/redo-customer-segments-common/marketing/segments/segment-condition-catalog";
import * as z from "zod";

export const getSegmentConditionCatalog = {
  name: "getSegmentConditionCatalog" as const,
  description:
    "Every dimension a segment condition can use, with its name, description, data type and valid operators, grouped by customer attribute and by activity. Read this before composing conditions: dimension ids are not guessable from their display names.",
  mutates: false,
  input: z.void(),
  output: segmentConditionCatalogSchema,
};
